// modules
import { createAction } from 'redux-actions'

export const setCaregiverList = createAction('SET_CAREGIVER_LIST')
export const setCaregiverEdit = createAction('SET_CAREGIVER_EDIT')

export const resetCaregiverManagement = createAction(
  'RESET_CAREGIVER_MANAGEMENT'
)
